import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SubscriptionService } from '../services/subscription.service';
import { AuthService } from './auth.service';

export const subscriptionGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const subscriptionService = inject(SubscriptionService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true; // Deixa o authGuard realizar o redirecionamento para o login
  }

  // Se o usuário está retornando da Stripe com indicação de sucesso,
  // permite a passagem para que a tela possa exibir o modal reativo e receber a confirmação
  if (route.queryParams?.['checkout'] === 'success') {
    return true;
  }

  const assinaturaAtual = subscriptionService.assinatura();
  if (assinaturaAtual) {
    if (assinaturaAtual.podeAcessar || assinaturaAtual.emGracePeriod) {
      return true;
    }
    return router.createUrlTree(['/planos'], { queryParams: { paywall: 'ativo' } });
  }

  // Se ainda não carregou a assinatura, carrega agora via HTTP
  return subscriptionService.carregarMinhaAssinatura().pipe(
    map((sub) => {
      if (sub && (sub.podeAcessar || sub.emGracePeriod)) {
        return true;
      }
      return router.createUrlTree(['/planos'], { queryParams: { paywall: 'ativo' } });
    }),
    catchError(() => {
      // Em caso de falha de rede temporária, permite a passagem para não interromper cultos
      return of(true);
    })
  );
};
